import { computed, ref } from 'vue'

// Whether the AI chat split pane is open. Module-level so the App-shell
// outlet (which animates its width) and HeaderAI (toggle button + panel
// content) stay in sync, following the use-ai-chat singleton pattern.
const open = ref(false)

// How many HeaderAI panels are currently mounted. Views without the chat
// (e.g. the hub) mount none, and the outlet must not hold width for a panel
// that is not there.
const mountedPanels = ref(0)

// What the App-shell outlet actually renders against: open AND a panel
// mounted. `open` survives visits to chat-less views, so the pane reappears
// when the user returns to a chart view.
const visible = computed(() => open.value && mountedPanels.value > 0)

/**
 * Shared state for the AI chat split pane.
 * @returns {{open: import('vue').Ref<boolean>, visible: import('vue').ComputedRef<boolean>, mountedPanels: import('vue').Ref<number>}} the shared panel state
 */
export const useAiPanel = () => ({ open, visible, mountedPanels })
